import request from '@/utils/request'
import { ReceiveScanReq, ReceiveScanRes } from './types'

/**
 * RGR08 센터도착 수령작업 — 반송장 스캔 판정. (moms-be LOGISPRD-9589)
 *
 * 2.0 신규 엔드포인트지만 봉투는 1.0 grid 래퍼 그대로다 — moms-be `ReceiveReturnReceiptRequestBody`
 * 가 FE(1.0 `grid.js` searchEpic) 호환을 위해 `{"params": "<JSON string>"}` 을 그대로 받는다.
 *
 * 같은 경로 `GET /api/v1/return/receipts` 는 RGR09 수령내역 조회다(`services/return/returnReceipt`).
 * 메서드로만 갈리므로 서비스 파일을 나눠 혼선을 막는다.
 */
export const RETURN_RECEIPT_RECEIVE_URL = '/api/v1/return/receipts'

const MENU_CD = 'RGR08_HEAD'

interface GridWrapperBody {
  params: string
}

/** `yyyy-MM-dd`(ISO) → `yyyyMMdd`. BE 는 압축형만 받는다(공란이면 서버가 오늘로 대체). */
const toCompactDate = (isoDate?: string): string => (isoDate ? isoDate.replaceAll('-', '') : '')

export const receiveReturnReceipt = (req: ReceiveScanReq) => {
  const inner = {
    MENU_CD,
    USR_ID: req.usrId,
    params: {
      CENTER_NM: req.centerNm,
      RTN_INVOICE_NO: req.rtnInvoiceNo,
      ASSIGN_DATE: toCompactDate(req.assignDate),
    },
  }

  return request.post<ReceiveScanRes, GridWrapperBody>(RETURN_RECEIPT_RECEIVE_URL, { params: JSON.stringify(inner) })
}
